import { getLastIssue } from '../../pages/issues/data'
// get last issue from issues list data
const last_issue =  getLastIssue()

// decrease from the last issue date, to get last time to receive researchs
let last_time_receiv = new Date(last_issue.date)
last_time_receiv.setDate(last_time_receiv.getDate()-8)

// decrease from the last time to receive researches , to show it on Ar
let last_time_receiv_arabic = new Date(last_time_receiv)
last_time_receiv_arabic.setDate(last_time_receiv.getDate()-1)
last_time_receiv_arabic = last_time_receiv_arabic.toLocaleDateString('ar-MA', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
});

const data=[
        {
            title:'آخر أجل لاستلام البحوث :',
            paragraph: last_time_receiv,
            date: last_time_receiv_arabic,
            img: require('../../images/slider-background-2.webp'),
            mokupImage: 'https://rmprs.com/plugins/themes/rmprsTheme/images/mokup.webp'
        },
        {
            title:`موعد إصدار ${last_issue.title} :`,
            paragraph: last_issue.date,
            date: last_issue.secondDate,
            img: require('../../images/slider-background-1.webp'),
            mokupImage: 'https://rmprs.com/plugins/themes/rmprsTheme/images/mokup.webp'
        },
    ]

export default data